import { createOutlineIcon } from "../createIcon";

export const MapOutlineIcon = createOutlineIcon(
  <>
    <path d="M8.625 16.0484V10.0246M14.8126 13.8579V7.8341M3 17.7151V4.00076L8.47826 6.28649L14.7391 4.00076L21 6.28649V20.0007L14.7391 17.7151L8.47826 20.0007L3 17.7151Z" />
  </>,
  "MapOutlineIcon"
);
